import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { loadFile } from '@/utils';
let LoginData = JSON.parse(loadFile('fstsign_.json'))

//读取值是否存在登录页字段
// 值意义: 1 为存在 2为不存在 可在fstsign_.json处修改对应值
let StuLoginShow = LoginData.LoginOpen.StuLogin;
let TeaLoginShow = LoginData.LoginOpen.TeaLogin;

const routes = [
	{
		path: '/',
		redirect: '/login',
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/Login.vue'), // 登录
	},
	{
		path: '/',
		name: 'layout',
		component: () => import('../views/Layout.vue'), // 头部-公用组件
		children: [
			{
				path: '',
				name: '',
				component: () => import('../views/MenuMap.vue'), // 导航栏侧栏菜单
				children: [
					{
						path: 'bacinfo',
						name: 'bacinfo',
						component: () => import('../views/index/BacInfo.vue'), // 背景介绍
					},
					{
						path: 'bacinfoeng',
						name: 'bacinfoeng',
						component: () => import('../views/index/BacInfo_eng.vue'), // 背景介绍
					},
					{
						path: 'experiment',
						name: 'experiment',
						component: () => import('../views/index/Experiment.vue'), // 实验介绍
					},
					{
						path: 'baseinfo',
						name: 'baseinfo',
						component: () => import('../views/index/BaseInfo.vue'), // 基础知识
					},
					{
						path: 'answer',
						name: 'answer',
						component: () => import('../views/index/Answer.vue'), // 知识问答
					},
					{
						path: 'check',
						name: 'check',
						component: () => import('../views/index/Check.vue'), // 普查数据情况
					},
					{
						path: 'step1',
						name: 'step1',
						component: () => import('../views/index/Step1.vue'), // 步骤1
					},
					{
						path: 'step2',
						name: 'step2',
						component: () => import('../views/index/Step2.vue'), // 步骤2
					},
					{
						path: 'step3Case1',
						name: 'step3Case1',
						component: () => import('../views/index/step3Case1.vue'), // 步骤3
					},
					{
						path: 'step3',
						name: 'step3',
						component: () => import('../views/index/Step3.vue'), // 步骤3
					},
					{
						path: 'intro',
						name: 'intro',
						component: () => import('../views/index/Introduce.vue'), // 物资储备及成本介绍
					},
					{
						path: 'step4',
						name: 'step4',
						component: () => import('../views/index/Step4.vue'), // 步骤4
					},
					{
						path: 'step5Case1',
						name: 'step5Case1',
						component: () => import('../views/index/Step5.vue'), // 步骤5
					},
					{
						path: 'step5Case2',
						name: 'step5Case2',
						component: () => import('../views/index/Step5.vue'), // 步骤5
					},
					{
						path: 'step6Case1',
						name: 'step6Case1',
						component: () => import('../views/index/Step6.vue'), // 步骤6
					},
					{
						path: 'step6Case2',
						name: 'step6Case2',
						component: () => import('../views/index/Step6.vue'), // 步骤6
					},
					{
						path: 'contrast',
						name: 'contrast',
						component: () => import('../views/index/Contrast.vue'), // 结果比对
					},
					{
						path: 'step7',
						name: 'step7',
						component: () => import('../views/index/Step7.vue'), // 步骤7
					},
					{
						path: 'weather',
						name: 'weather',
						component: () => import('../views/index/Weather.vue'), // 设置天气预报
					},
					{
						path: 'delivery',
						name: 'delivery',
						component: () => import('../views/index/Delivery.vue'), // 应急物流配送
					},
				],
			},
		],
	},
	{
		path: '/adminlogin',
		name: 'adminlogin',
		component: () => import('@/views/AdminIndex/Login.vue'), // 教师端登录
	},
	{
		path: '/adminindex',
		name: 'adminindex',
		component: () => import('@/views/AdminIndex/Index.vue'), // 教师端首页
	},
];

const router = createRouter({
	//history: createWebHistory(process.env.BASE_URL),
	history: createWebHashHistory(),
	routes,
});
if(StuLoginShow == 2){
	router.removeRoute('login')
}
if(TeaLoginShow == 2){
	router.removeRoute('adminlogin')
}

export default router;
